document.addEventListener("DOMContentLoaded", function () {
  const popup = document.querySelector(".popup");
  const popupCloseBtn = document.querySelector(".popup__banner-close");
  const puBanner = document.querySelector(".pu-banner");
  const puBannerCloseBtn = document.querySelector(".pu-banner__close");
  const body = document.body;

  if (!popup || !puBanner) return;

  // ARIA dla dostępności
  puBanner.setAttribute("role", "dialog");
  puBanner.setAttribute("aria-modal", "true");
  puBanner.setAttribute("aria-hidden", "true");

  function openOverlay() {
    puBanner.classList.add("is-open");
    puBanner.setAttribute("aria-hidden", "false");
    popup.classList.add("is-offscreen");
    body.classList.add("no-scroll");
    // przenieś fokus na przycisk zamykania
    if (puBannerCloseBtn) puBannerCloseBtn.focus({ preventScroll: true });
  }

  function closeOverlay() {
    puBanner.classList.remove("is-open");
    puBanner.setAttribute("aria-hidden", "true");
    popup.classList.remove("is-offscreen");
    body.classList.remove("no-scroll");
  }

function setCookie(name, value, forever = false) {
  const d = new Date();
  if(forever){
    d.setFullYear(d.getFullYear() + 10); // cookie ważne przez 10 lat
  } else{
    d.setTime(d.getTime() + (24 * 60 * 60 * 1000)); // 24h w milisekundach
  }
  let expires = "expires=" + d.toUTCString();
  document.cookie = name + "=" + value + ";" + expires + ";path=/";
}
  
  function getCookie(name) {
    let cname = name + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i < ca.length; i++) {
      let c = ca[i].trim();
      if (c.indexOf(cname) === 0) {
        return c.substring(cname.length, c.length);
      }
    }
    return "";
  }

  // 1) Klik w .popup -> otwiera overlay
  popup.addEventListener("click", function () {
    openOverlay();
  });

  // 2) Klik w X na popupie -> zamyka pasek boczny
  if (popupCloseBtn) {
    // przy zamknięciu popupu (X z boku)
    popupCloseBtn.addEventListener("click", function (e) {
        e.stopPropagation();
        popup.style.display = "none";
        setCookie("popupClosed", "true");
    });
  
    // na starcie sprawdź
    if (getCookie("popupClosed") !== "true") {
        popup.style.display = "block";

        const params = new URLSearchParams(window.location.search);
        const hasCustomerPosted = params.get("customer_posted") === "true";
        // sprawdzenie czy #contact_form
        const hasContactFormHash = window.location.hash === "#contact_form";

        if (hasCustomerPosted && hasContactFormHash) {
          setTimeout(() => {
            openOverlay();
            setCookie("popupClosed", "true", true);
            popup.style.display = "none";

          }, 10);
          openOverlay();
        } else {
          setTimeout(() => {
              openOverlay();
          }, 5000);
        }

        // customer_posted=true#contact_form

    }
  }

  // 3) Klik w X na overlayu -> zamyka overlay
  if (puBannerCloseBtn) {
    puBannerCloseBtn.addEventListener("click", function (e) {
      e.stopPropagation();
      closeOverlay();
    });
  }

  // 4) Klik w tło overlayu (poza kartą) -> zamyka overlay
  puBanner.addEventListener("click", function (e) {
    // zamknij tylko jeśli kliknięto bezpośrednio w overlay (nie w zawartość)
    if (e.target === puBanner) {
      closeOverlay();
    }
  });

  // 5) Esc zamyka overlay
  document.addEventListener("keydown", function (e) {
    if (e.key === "Escape" && puBanner.classList.contains("is-open")) {
      closeOverlay();
    }
  });

  // Startowo overlay ukryty (klasami), popup widoczny
  puBanner.classList.remove("is-open");
  puBanner.setAttribute("aria-hidden", "true");
  popup.classList.remove("is-offscreen");
});